// extracted by mini-css-extract-plugin
export default {"textItem":"TextWithAlts_textItem__I3a8V","altsItem":"TextWithAlts_altsItem__5AiH4","altSelected":"TextWithAlts_altSelected__sojNk","button":"TextWithAlts_button__iDBIo"};